import React, { useState } from "react";

const Translate = () => {
  const [currentLang, setCurrentLang] = useState(() => {
    const match = document.cookie.match(/(?:^|; )googtrans=([^;]*)/);
    if (match) {
      const parts = match[1].split("/");
      const lang = parts[parts.length - 1];
      return lang && lang !== "en" ? lang : "en";
    }
    return "en";
  });

  const changeLanguage = (e) => {
    const langCode = e.target.value;
    setCurrentLang(langCode);

    const host = window.location.hostname;
    const domainParts = host.split(".");
    const baseDomain =
      domainParts.length > 1 ? "." + domainParts.slice(-2).join(".") : host;

    if (langCode === "en") {
      document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${baseDomain}`;
      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${host}`;
    } else {
      document.cookie = `googtrans=/en/${langCode}; path=/`;
      document.cookie = `googtrans=/en/${langCode}; path=/; domain=${baseDomain}`;
      document.cookie = `googtrans=/en/${langCode}; path=/; domain=${host}`;
    }

    // Trigger deterministic page translation reload without DOM mutation conflicts
    window.location.reload();
  };

  return (
    <div
      className="translate-dropdown fixed top-[5.5rem] lg:top-[5rem] right-2 sm:right-4 z-30 flex justify-end notranslate"
      translate="no"
    >
      <select
        value={currentLang}
        onChange={changeLanguage}
        className="bg-white border border-black p-2 text-xs sm:text-sm rounded-lg cursor-pointer shadow-sm outline-none notranslate font-sans"
        translate="no"
      >
        <option value="en" className="notranslate" translate="no">
          English
        </option>
        <option value="hi" className="notranslate" translate="no">
          Hindi
        </option>
        <option value="es" className="notranslate" translate="no">
          Spanish
        </option>
        <option value="fr" className="notranslate" translate="no">
          French
        </option>
        <option value="de" className="notranslate" translate="no">
          German
        </option>
        <option value="th" className="notranslate" translate="no">
          Thai
        </option>
        <option value="ms" className="notranslate" translate="no">
          Malay
        </option>
        <option value="it" className="notranslate" translate="no">
          Italian
        </option>
        <option value="zh-CN" className="notranslate" translate="no">
          Chinese
        </option>
      </select>
    </div>
  );
};

export default Translate;
